import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { type RouteAppComponentProps } from "@/router/routes";
import { setPageTitle } from "@/utils/hook";

import { AppPasswordRecoveryView, PasswordRecoveryStep } from "./view";

function _AppPasswordRecovery(props: RouteAppComponentProps) {
  const mode = props.routeType === "set" ? "set" : "recovery";
  const [params] = useSearchParams();
  const [currentStep, setCurrentStep] = useState<PasswordRecoveryStep>(
    PasswordRecoveryStep.emailInput
  );
  useEffect(() => {
    if (
      params.get("user_id") &&
      params.get("signature") &&
      params.get("timestamp")
    ) {
      setCurrentStep(PasswordRecoveryStep.newPassword);
    }
  }, [params]);
  useEffect(() => {
    setPageTitle(window)(props.pageName)();
  }, []);
  return (
    <AppPasswordRecoveryView
      mode={mode}
      currentStep={currentStep}
      onNextStepClicked={() =>
        setCurrentStep((prev) => {
          switch (prev) {
            case PasswordRecoveryStep.emailInput:
              return PasswordRecoveryStep.sendSuccess;
            case PasswordRecoveryStep.sendSuccess:
              return PasswordRecoveryStep.newPassword;
            default:
              return PasswordRecoveryStep.emailInput;
          }
        })
      }
      onPrevStepClicked={() => setCurrentStep(PasswordRecoveryStep.emailInput)}
    />
  );
}

const AppPasswordRecovery = _AppPasswordRecovery;

export default AppPasswordRecovery;
